module.exports = __webpack_public_path__ + "static/media/nb_add_to_apple_wallet.c81753b1.svg";